import cloneDeep from "lodash/cloneDeep";
import merge from "lodash/merge";
import { Module } from "vuex";
import baseModule from "./common";
import { Fetcher as Ajax } from "@/utils/Request";
import { API_EXPENSE_CATEGORY } from "@/configs/Apis";
const newModule: Module<any, any> = merge(cloneDeep(baseModule), {
  actions: {
    addExpenseCategory(store: any, payload: any) {
      return Ajax.saveData(API_EXPENSE_CATEGORY, payload, "POST");
    },
    updateExpenseCategory(store: any, payload: any) {
      return Ajax.saveData(API_EXPENSE_CATEGORY + "/" + payload.id, payload, "PUT");
    },
    deleteExpenseCategory(store: any, categoryFilter: any) {
      return Ajax.saveData(API_EXPENSE_CATEGORY, categoryFilter, "DELETE");
    },
  }
});
export default newModule;
